import * as React from "react";
import { cn } from "~/lib/utils";
import { RadioGroupItem as RadioGroupItemComponent } from "~/components/ui/radio-group";

type RadioGroupItemProps = React.ComponentProps<typeof RadioGroupItemComponent>;

export function RadioGroupItem({ className, ...props }: RadioGroupItemProps) {
  return (
    <RadioGroupItemComponent
      className={cn(
        //
        "size-5 border-gray-300 bg-white",
        "data-[state=checked]:bg-secondary-700 data-[state=checked]:border-secondary-700",
        "data-[state=checked]:[&_svg]:fill-white data-[state=checked]:[&_svg]:stroke-white",
        className
      )}
      {...props}
    />
  );
}
